import { IntlShape } from "react-intl";
import { TPost } from "../api";
import { IScore } from "../score";
import { IMelodyTableData } from "./melodyTable";
import { ITonesetStaffData } from "./tonesetStaff";
import { IPianoData } from "./piano";
import { ISolfanameData } from "./solfaName";
import { IHandsignData } from "./handsign";
import { IEmbedData } from "./embed";
import { ISingingData } from "./singing";
import { IBarlineData } from "./barline";
import { IRhytNotationData } from "./rhytnotation";
import { IFlowData } from "./flow";
import { IRhytSortingData } from "./rhytsorting";
import { IChords3Data } from "./chords3";
import { IIntervalsData } from "./intervals";
import { IRhytNameData } from "./rhytname";
import { IRhytKnockData } from "./rhytknock";
import { IBarsortingData } from "./barsorting";
import { IBarsorting2Data } from "./barsorting2";
import { ISubScoreData } from "./subScore";
import { IMeta } from "./meta";
import theme from "../../../front/style/theme";
import { ISelectEvent } from "../../../front/types";
import { IUser, RhythmSyllableType } from "../../../front/store/user/models";
import { IEditTask } from "../../../front/store/plan/models/planActions";

export * from "./melodyTable";
export * from "./tonesetStaff";
export * from "./solfaNameType";
export * from "./piano";
export * from "./solfaName";
export * from "./handsign";
export * from "./embed";
export * from "./singing";
export * from "./rhytnotation";
export * from "./flow";
export * from "./rhytsorting";
export * from "./chords3";
export * from "./intervals";
export * from "./rhytname";
export * from "./barsorting";
export * from "./barsorting2";
export * from "./barline";
export * from "./meta";
export * from "./subScore";

export type IScoreReference = {
    _id: string,
    score: IScore,
    tempo: number,
    scale: number,
    index?: number,
}

export enum ExperienceTheme {
    Easter = "easter",
    Christmas = "christmas"
}

export type IPlan = {
    _id: string,
    tasks: ITask[];
    user: string;
    scores: IScoreReference[],
    name: {
        [language: string]: string,
    },
    description: {
        [language: string]: string,
    },
    accepted?: boolean,
    public?: boolean,
    experience: {
        enabled?: boolean,
        positions: (number | null | number[])[],
        order?: ExperienceOrder,
        score?: number | string,
        theme?: ExperienceTheme,
    },
    experienceLoading?: boolean,
    cover?: string,
    audio?: string,
    audioSize?: number,
    meta: IMeta,
    packName?: string,
    copyright?: boolean,
    reviewed?: boolean,
    modified?: number,
    published?: number,
    sharable?: boolean,
    metaDone?: boolean,
    shared?: boolean,
    playable?: boolean,
    publicId?: string,
    refreshInProgress?: boolean,
    created: number,
    redirect?: boolean,
    notFound?: boolean,
    publicDate?: number,
    loading?: boolean,
    pack?: string,
    views?: number,
    originalId?: string,
    updated?: boolean,
    total?: number,

    //homework
    date?: number,
    startDate?: number,
    planId?: string,
    isArchived?: boolean,
    userData?: {
        username: string,
        displayName: string,
        created?: number,
        profilePicture: string,
    } | "anonymous"
};
export interface ITaskEditorProps {
    plan: IPlan,
    inlineEditorOpen: boolean,
    toggleInlineEditor: (state: boolean) => void,
    taskIndex: number,
    post: TPost,
    editTask: (data: IEditTask["payload"]) => void,
    publicView: boolean,
    intl?: IntlShape,
    reload?: () => void,
    playable: boolean,
    viewProps: {
        height: number,
        paddingTop: number,
    },
    theme?: typeof theme,
    isScaleAlert?: boolean,
    changeRhythmSyllableType?: (e: ISelectEvent<RhythmSyllableType>) => void,
    user?: IUser,
    removeTaskProp?: (props: { taskIndex: number, removingProp: string }) => void,
}

export interface ITaskEditorState {
    openChanger?: string,
    playable: boolean,
}

export type TShowPitchesTaskData = IPianoData | ISolfanameData | IHandsignData;
export type TScoreData = IPianoData | ISolfanameData | IHandsignData | ISingingData | IRhytNotationData | IChords3Data | IIntervalsData | IRhytNameData | IRhytKnockData | IBarsorting2Data | IBarlineData;
export type TTempoData = IPianoData | ISolfanameData | IRhytSortingData | IMelodyTableData | ITonesetStaffData | IHandsignData | ISingingData | IRhytNotationData | IChords3Data | IIntervalsData | IRhytNameData | IRhytKnockData | IBarsorting2Data | IBarlineData;

export type ITask = {
    type: string,
    description?: string,
    data: IMelodyTableData | ITonesetStaffData | IFlowData | IPianoData | ISolfanameData | IRhytSortingData | IEmbedData | IHandsignData | ISingingData | IRhytNotationData | IChords3Data | IIntervalsData | IRhytNameData | IRhytKnockData | IBarsorting2Data | IBarsortingData | IBarlineData | ISubScoreData,
    ref?: string,
    id: number,
};


export interface ICommonTaskProps {
    setReset: (resetTask: () => void) => void,
    saveState: (saveState: () => any) => void,
    restoreState: (restoreState: (state: any) => void) => void,
    showSolution: (showSolution: () => void) => void,
    preview?: boolean,
    isLow?: boolean,
    playPlan?: boolean,
    join?: boolean,
    task: ITask,
    plan: IPlan,
    completed: (taskType: string, skipped?: boolean) => void,
    handleFailCount?: () => void,
    handlePlayCount?: () => void,
    isDemo?: boolean,
    handleHomeworkNext?: () => void,
    edit?: boolean,
    tempo?: number,
    isExperienceCenter?: boolean,
    isEaster?: boolean;
    isChristmas?: boolean;
    isExperience?: boolean,
}

export enum ExperienceOrder {
    Fix = 0,
    Free = 1,
}